import type { WorkbookTask } from '@erp/rpc';
import type { WorkbookRun, WorkbookTaskRule } from '@erp/shared-types';

type RunLike = Pick<WorkbookRun, 'id' | 'status'> & {
  results: readonly Pick<WorkbookRun['results'][number], 'sheetId'>[];
};

/** Whether a Run completed and computed the Worksheet of one of the rules. */
function feedsRules(run: RunLike, rules: readonly WorkbookTaskRule[]) {
  return (
    run.status === 'completed' &&
    run.results.some((result) =>
      rules.some((rule) => rule.sheetId === result.sheetId),
    )
  );
}

/**
 * What Run History shows about one Run's Tasks: the Tasks it opened, and
 * whether Open Tasks applies the Task rules to it by hand. That is offered
 * only on the newest completed Run a rule reads, and only while it opened
 * none (its rules were added after it ran); older Runs may predate the rules.
 */
export function runTaskState(
  run: RunLike,
  runs: readonly RunLike[],
  rules: readonly WorkbookTaskRule[],
  tasks: readonly WorkbookTask[],
) {
  const opened = tasks.filter((task) => task.workbookRunId === run.id);
  const newest = runs.find((item) => feedsRules(item, rules));
  return {
    opened,
    canOpen: newest?.id === run.id && opened.length === 0,
  };
}
